// extracted by mini-css-extract-plugin
export default {"host":"styles_host__HxcLm","orb":"styles_orb__vu2F7","horizontal":"styles_horizontal__+4M6T","vertical":"styles_vertical__gxDI3"};